"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _baseModel = /*#__PURE__*/ _interopRequireDefault(require("./BaseModel"));
var _axisValidators = /*#__PURE__*/ _interopRequireDefault(require("../validators/AxisValidators"));
var _axisSchema = require("../schemas/AxisSchema");
var _motorSettings = /*#__PURE__*/ _interopRequireDefault(require("../schemas/external/MotorSettings"));
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var AxisModel = /*#__PURE__*/ function(BaseModel) {
    "use strict";
    _inherits(AxisModel, BaseModel);
    var _super = _createSuper(AxisModel);
    function AxisModel() {
        _classCallCheck(this, AxisModel);
        return _super.call(this, _axisSchema.schema, _axisSchema.schemaMap, _axisValidators.default);
    }
    var _proto = AxisModel.prototype;
    _proto.getMotorSettings = function getMotorSettings(motorSize) {
        return _motorSettings.default[motorSize];
    };
    _proto.getAxisTypesCompatibleWithConfigChecker = function getAxisTypesCompatibleWithConfigChecker() {
        return _axisSchema.schemaMap.parameters.axisType.configCheckerCompatibility.compatible;
    };
    _proto.getMmPerRotationForAxisType = function getMmPerRotationForAxisType(axisType) {
        return _axisSchema.schemaMap.parameters.mmPerRotation.axisTypeMapping[axisType];
    };
    _proto.getCompatibleMotorSizesForAxisType = function getCompatibleMotorSizesForAxisType(axisType) {
        return _axisSchema.schemaMap.parameters.motorSize.values.filter(function(size) {
            return _motorSettings.default[size] && _motorSettings.default[size].allowedAxisType.includes(axisType);
        });
    };
    _proto.isAxisTypeConveyorTurnTableCompatible = function isAxisTypeConveyorTurnTableCompatible(axisType) {
        return [
            "custom",
            "indexer_v2"
        ].includes(axisType);
    };
    _proto.isAxisTypeGearboxCompatible = function isAxisTypeGearboxCompatible(axisType) {
        return _axisSchema.schemaMap.parameters.multiplier.axisTypeCompatibility.compatible.includes(axisType);
    };
    _proto.isAxisTypeBrakeCompatible = function isAxisTypeBrakeCompatible(axisType) {
        return !_axisSchema.schemaMap.parameters.brake.axisTypeCompatibility.incompatible.includes(axisType);
    };
    return AxisModel;
}(_baseModel.default);
var _default = AxisModel;
